var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "single__wrapper-inner" },
    [
      _c(
        "div",
        { staticClass: "fixed-product-box" },
        [
          _vm.attributes.length || Object.keys(_vm.units).length
            ? [
                _c("variation-select", {
                  attrs: {
                    type: "mobile",
                    "attribute-size-id":
                      _vm.napoConfig.itemLists.attributeSizeId,
                    "attribute-color-id":
                      _vm.napoConfig.itemLists.attributeColorId,
                  },
                }),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c("add-to-basket", {
            attrs: {
              "variation-id": _vm.currentVariation.variation.id,
              "is-salable":
                !!_vm.currentVariation.filter &&
                _vm.currentVariation.filter.isSalable,
              "has-children":
                !!_vm.currentVariation.filter &&
                _vm.currentVariation.filter.hasActiveChildren,
              "interval-quantity":
                _vm.currentVariation.variation.intervalOrderQuantity || 1,
              "minimum-quantity":
                _vm.currentVariation.variation.minimumOrderQuantity,
              "maximum-quantity":
                !!_vm.currentVariation.variation.maximumOrderQuantity &&
                _vm.currentVariation.variation.maximumOrderQuantity > 0
                  ? _vm.currentVariation.variation.maximumOrderQuantity
                  : null,
              "order-properties": _vm.currentVariation.properties.filter(
                function (prop) {
                  return prop.property.isOderProperty
                }
              ),
              "use-large-scale": false,
              "show-quantity": true,
              "item-url": _vm._f("itemURL")(_vm.currentVariation),
              "is-variation-selected":
                _vm.isVariationSelected &&
                _vm.currentVariation.filter.isSalable,
              "has-price": _vm._f("hasItemDefaultPrice")(_vm.currentVariation),
              type: "mobile",
            },
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "single__head" }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c("breadcrumbs", {
                  attrs: { template: "#vue-category-breadcrumbs" },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-12" }, [
              _c("h1", { staticClass: "details__name" }, [
                _vm._v(
                  "\n                        " +
                    _vm._s(_vm._f("itemName")(_vm.currentVariation)) +
                    "\n                    "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-lg-7 col-xl-8 single__left" },
              [
                _c(
                  "div",
                  { staticClass: "single__btn-group" },
                  [
                    _c("div", { staticClass: "position-relative" }, [
                      _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "toggle-social-share",
                              rawName: "v-toggle-social-share",
                            },
                          ],
                          staticClass: "single__share-btn",
                        },
                        [
                          _c("span", [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(
                                  _vm.$translate(
                                    "ODFashioncode::Fashioncode.singleShare"
                                  )
                                ) +
                                "\n                                "
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "single__share-container single__share-container--hidden",
                        },
                        [_vm._t("social-share")],
                        2
                      ),
                    ]),
                    _vm._v(" "),
                    _c("add-to-wish-list", {
                      attrs: {
                        "variation-id":
                          _vm.currentVariation &&
                          _vm.currentVariation.variation.id,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._t("image-carousel"),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-7 col-lg-5 col-xl-4 single__right" },
              [
                _c("div", { staticClass: "details" }, [
                  _c(
                    "div",
                    { staticClass: "details__name-wrap" },
                    [
                      _vm.currentVariation &&
                      _vm.currentVariation.item.storeSpecial
                        ? [
                            _vm.currentVariation.item.storeSpecial.id == 1
                              ? _c("div", [
                                  _c(
                                    "div",
                                    { staticClass: "item__tag item__tag--pdp" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "item__tag--sale" },
                                        [
                                          _vm._v(
                                            "\n                                            " +
                                              _vm._s(
                                                _vm.$translate(
                                                  "ODFashioncode::Fashioncode.storeSpecialOffer"
                                                )
                                              ) +
                                              "\n                                        "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.currentVariation.item.storeSpecial.id == 2
                              ? _c("div", [
                                  _c(
                                    "div",
                                    { staticClass: "item__tag item__tag--pdp" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "item__tag--new" },
                                        [
                                          _vm._v(
                                            "\n                                            " +
                                              _vm._s(
                                                _vm.$translate(
                                                  "ODFashioncode::Fashioncode.storeSpecialNew"
                                                )
                                              ) +
                                              "\n                                        "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.currentVariation.item.storeSpecial.id == 3
                              ? _c("div", [
                                  _c(
                                    "div",
                                    { staticClass: "item__tag item__tag--pdp" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "item__tag--top" },
                                        [
                                          _vm._v(
                                            "\n                                            " +
                                              _vm._s(
                                                _vm.$translate(
                                                  "ODFashioncode::Fashioncode.storeSpecialTop"
                                                )
                                              ) +
                                              "\n                                        "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentVariation.filter.hasManufacturer
                        ? _c(
                            "div",
                            { staticClass: "details__producer" },
                            [
                              _vm.manufacturerLink
                                ? [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          title: _vm.manufacturer.name,
                                          href: _vm.manufacturerLink,
                                        },
                                      },
                                      [
                                        _vm.manufacturer.logo != ""
                                          ? [
                                              _c("img", {
                                                attrs: {
                                                  src: _vm.manufacturer.logo,
                                                  alt: _vm.manufacturer.name,
                                                },
                                              }),
                                            ]
                                          : [
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(
                                                    _vm.manufacturer.name
                                                  ) +
                                                  "\n                                        "
                                              ),
                                            ],
                                      ],
                                      2
                                    ),
                                  ]
                                : [
                                    _vm.manufacturer.logo != ""
                                      ? [
                                          _c("img", {
                                            attrs: {
                                              src: _vm.manufacturer.logo,
                                              alt: _vm.manufacturer.name,
                                            },
                                          }),
                                        ]
                                      : [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(_vm.manufacturer.name) +
                                              "\n                                    "
                                          ),
                                        ],
                                  ],
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._t("before-price"),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "single-price" },
                        [
                          _vm.currentVariation.prices.rrp &&
                          _vm.currentVariation.prices.rrp.price.value > 0 &&
                          _vm.currentVariation.prices.rrp.price.value >
                            _vm.currentVariation.prices.default.price.value
                            ? _c(
                                "div",
                                { staticClass: "single-price__crossprice" },
                                [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        _vm.currentVariation.prices.rrp.price
                                          .formatted
                                      ) +
                                      "\n                                "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              ref: "variationTotalPrice",
                              staticClass: "single-price__price",
                              class: {
                                "single-price__price--sale":
                                  _vm.currentVariation.prices.rrp &&
                                  _vm.currentVariation.prices.rrp.price.value >
                                    0 &&
                                  _vm.currentVariation.prices.rrp.price.value >
                                    _vm.currentVariation.prices.default.price
                                      .value,
                              },
                              attrs: {
                                content:
                                  _vm.currentVariation.prices.default.price
                                    .value,
                              },
                            },
                            [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(
                                    _vm._f("currency")(
                                      _vm.variationTotalPrice,
                                      _vm.currentVariation.prices.default
                                        .currency
                                    )
                                  ) +
                                  "\n                                "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "single-price__vat" },
                            [
                              _vm.showNetPrices
                                ? [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.singleItemExclVAT"
                                        )
                                      )
                                    ),
                                  ]
                                : [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.singleItemInclVAT"
                                        )
                                      )
                                    ),
                                  ],
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$translate(
                                      "Ceres::Template.singleItemExclusive"
                                    )
                                  ) +
                                  " \n                                    "
                              ),
                              _vm.ceresConfig.global.shippingCostsCategoryId !==
                              ""
                                ? _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: "#",
                                        "data-toggle": "modal",
                                        "data-target":
                                          "#id--shipping-costs-modal",
                                        title: _vm.$translate(
                                          "ODFashioncode::Fashioncode.singleShipping"
                                        ),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(
                                            _vm.$translate(
                                              "ODFashioncode::Fashioncode.singleShipping"
                                            )
                                          ) +
                                          "\n                                    "
                                      ),
                                    ]
                                  )
                                : [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(
                                          _vm.$translate(
                                            "ODFashioncode::Fashioncode.singleShipping"
                                          )
                                        ) +
                                        "\n                                    "
                                    ),
                                  ],
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _vm._t("additional-content-after-vat"),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "single__item-number" }, [
                        _vm._v(
                          "\n                                " +
                            _vm._s(
                              _vm.$translate(
                                "ODFashioncode::Fashioncode.singleItemNumber"
                              )
                            ) +
                            " " +
                            _vm._s(_vm.currentVariation.variation.number) +
                            "\n                            "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("graduated-prices", {
                        attrs: { template: "#vue-graduated-prices" },
                      }),
                      _vm._v(" "),
                      _vm._t("after-price"),
                      _vm._v(" "),
                      _vm._t("before-add-to-basket"),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "single__variant-select" },
                        [
                          _vm.attributes.length || Object.keys(_vm.units).length
                            ? [
                                _c("variation-select", {
                                  attrs: {
                                    type: "desktop",
                                    "attribute-size-id":
                                      _vm.napoConfig.itemLists.attributeSizeId,
                                    "attribute-color-id":
                                      _vm.napoConfig.itemLists.attributeColorId,
                                  },
                                }),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm.currentVariation.filter.isSalable &&
                      _vm.variationGroupedProperties.length
                        ? _c("div", [_c("order-property-list")], 1)
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          attrs: {
                            "data-article-id": _vm.currentVariation.item.id,
                          },
                        },
                        [
                          _c("add-to-basket", {
                            attrs: {
                              "variation-id": _vm.currentVariation.variation.id,
                              "is-salable":
                                !!_vm.currentVariation.filter &&
                                _vm.currentVariation.filter.isSalable,
                              "has-children":
                                !!_vm.currentVariation.filter &&
                                _vm.currentVariation.filter.hasActiveChildren,
                              "interval-quantity":
                                _vm.currentVariation.variation
                                  .intervalOrderQuantity || 1,
                              "minimum-quantity":
                                _vm.currentVariation.variation
                                  .minimumOrderQuantity,
                              "maximum-quantity":
                                !!_vm.currentVariation.variation
                                  .maximumOrderQuantity &&
                                _vm.currentVariation.variation
                                  .maximumOrderQuantity > 0
                                  ? _vm.currentVariation.variation
                                      .maximumOrderQuantity
                                  : null,
                              "order-properties":
                                _vm.currentVariation.properties.filter(
                                  function (prop) {
                                    return prop.property.isOderProperty
                                  }
                                ),
                              "use-large-scale": false,
                              "show-quantity": true,
                              "item-url": _vm._f("itemURL")(
                                _vm.currentVariation
                              ),
                              "is-variation-selected":
                                _vm.isVariationSelected &&
                                _vm.currentVariation.filter.isSalable,
                              "has-price": _vm._f("hasItemDefaultPrice")(
                                _vm.currentVariation
                              ),
                              type: "desktop",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._t("after-add-to-basket"),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass:
                            "details__size-cta details__size-cta--mobile",
                          attrs: {
                            "data-toggle": "modal",
                            "data-target": "#id--single-size-modal",
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(
                                  _vm.$translate(
                                    "ODFashioncode::Fashioncode.sizeTable"
                                  )
                                ) +
                                "\n                                "
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("item-availability"),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "single__description d-lg-none" },
                        [
                          _c(
                            "div",
                            { staticClass: "single__description-col" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "single__description-headline collapsed",
                                  attrs: {
                                    type: "button",
                                    id: "id--single-collapse-heading--1",
                                    "data-toggle": "collapse",
                                    "data-target": "#id--single-collapse--1",
                                    "aria-expanded": "false",
                                    "aria-controls": "id--single-collapse--1",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(
                                        _vm.$translate(
                                          "ODFashioncode::Fashioncode.singleDescription"
                                        )
                                      ) +
                                      "\n                                    "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "collapse",
                                  attrs: {
                                    id: "id--single-collapse--1",
                                    "aria-labelledby":
                                      "id--single-collapse-heading--1",
                                  },
                                },
                                [
                                  _c("div", {
                                    staticClass: "single__description-text",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.currentVariation.texts.description
                                      ),
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "single__description-col" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "single__description-headline collapsed",
                                  attrs: {
                                    type: "button",
                                    id: "id--single-collapse-heading--2",
                                    "data-toggle": "collapse",
                                    "data-target": "#id--single-collapse--2",
                                    "aria-expanded": "false",
                                    "aria-controls": "id--single-collapse--2",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(
                                        _vm.$translate(
                                          "ODFashioncode::Fashioncode.singleShippingCosts"
                                        )
                                      ) +
                                      "\n                                    "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "collapse",
                                  attrs: {
                                    id: "id--single-collapse--2",
                                    "aria-labelledby":
                                      "id--single-collapse-heading--2",
                                  },
                                },
                                [
                                  _c("div", {
                                    staticClass: "single__description-text",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$translate(
                                          "ODFashioncode::Fashioncode.singleShippingContent"
                                        )
                                      ),
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "single__description-col" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "single__description-headline collapsed",
                                  attrs: {
                                    type: "button",
                                    id: "id--single-collapse-heading--3",
                                    "data-toggle": "collapse",
                                    "data-target": "#id--single-collapse--3",
                                    "aria-expanded": "false",
                                    "aria-controls": "id--single-collapse--3",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(
                                        _vm.$translate(
                                          "ODFashioncode::Fashioncode.singleShippingReturn"
                                        )
                                      ) +
                                      "\n                                    "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "collapse",
                                  attrs: {
                                    id: "id--single-collapse--3",
                                    "aria-labelledby":
                                      "id--single-collapse-heading--3",
                                  },
                                },
                                [
                                  _c("div", {
                                    staticClass: "single__description-text",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$translate(
                                          "ODFashioncode::Fashioncode.singleShippingReturnContent"
                                        )
                                      ),
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    2
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-5 col-lg-12 details__usp-col" }, [
              _c("ul", { staticClass: "details__usp" }, [
                _c("li", { staticClass: "d-lg-none" }, [
                  _c("p", { staticClass: "h4 mb-3" }, [
                    _vm._v(
                      "\n                                " +
                        _vm._s(
                          _vm.$translate(
                            "ODFashioncode::Fashioncode.singleAdvantages"
                          )
                        ) +
                        "\n                            "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "details__usp-item details__usp-item--1" },
                  [
                    _vm._v(
                      "\n                            " +
                        _vm._s(
                          _vm.$translate(
                            "ODFashioncode::Fashioncode.singleAdvantage1"
                          )
                        ) +
                        "\n                        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "details__usp-item details__usp-item--2" },
                  [
                    _vm._v(
                      "\n                            " +
                        _vm._s(
                          _vm.$translate(
                            "ODFashioncode::Fashioncode.singleAdvantage2"
                          )
                        ) +
                        "\n                        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "details__usp-item details__usp-item--3" },
                  [
                    _vm._v(
                      "\n                            " +
                        _vm._s(
                          _vm.$translate(
                            "ODFashioncode::Fashioncode.singleAdvantage3"
                          )
                        ) +
                        "\n                        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "details__usp-item details__usp-item--4" },
                  [
                    _vm._v(
                      "\n                            " +
                        _vm._s(
                          _vm.$translate(
                            "ODFashioncode::Fashioncode.singleAdvantage4"
                          )
                        ) +
                        "\n                        "
                    ),
                  ]
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "single__description container d-none d-lg-block",
          attrs: { id: "js--toggle-wrapper" },
        },
        [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-lg-4" }, [
              _c("p", { staticClass: "single__description-headline h4" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(
                      _vm.$translate(
                        "ODFashioncode::Fashioncode.singleDescription"
                      )
                    ) +
                    "\n                "
                ),
              ]),
              _vm._v(" "),
              _c("div", {
                staticClass: "single__description-text",
                domProps: {
                  innerHTML: _vm._s(_vm.currentVariation.texts.description),
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-lg-4" }, [
              _c("p", { staticClass: "single__description-headline h4" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(
                      _vm.$translate(
                        "ODFashioncode::Fashioncode.singleShippingCosts"
                      )
                    ) +
                    "\n                "
                ),
              ]),
              _vm._v(" "),
              _c("div", {
                staticClass: "single__description-text",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$translate(
                      "ODFashioncode::Fashioncode.singleShippingContent"
                    )
                  ),
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-lg-4" }, [
              _c("p", { staticClass: "single__description-headline h4" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(
                      _vm.$translate(
                        "ODFashioncode::Fashioncode.singleShippingReturn"
                      )
                    ) +
                    "\n                "
                ),
              ]),
              _vm._v(" "),
              _c("div", {
                staticClass: "single__description-text",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$translate(
                      "ODFashioncode::Fashioncode.singleShippingReturnContent"
                    )
                  ),
                },
              }),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "single__description-btn",
          attrs: { id: "js--toggle-text" },
        },
        [
          _c("span", { staticClass: "single__description-btn-text" }, [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.$translate("ODFashioncode::Fashioncode.seoShowMore")
                ) +
                "\n        "
            ),
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass:
                "single__description-btn-text single__description-btn-text--open",
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.$translate("ODFashioncode::Fashioncode.seoShowLess")
                  ) +
                  "\n        "
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _vm._t("item-list-container"),
      _vm._v(" "),
      _c("div", { attrs: { id: "single-size-modal-wrapper" } }, [
        _c(
          "div",
          {
            staticClass: "modal fade",
            attrs: {
              id: "id--single-size-modal",
              tabindex: "-1",
              role: "dialog",
            },
          },
          [
            _c("div", { staticClass: "modal-dialog" }, [
              _c(
                "div",
                { staticClass: "modal__content" },
                [
                  _c("div", { staticClass: "modal__header" }, [
                    _c(
                      "button",
                      {
                        staticClass: "modal__close",
                        attrs: {
                          type: "button",
                          "data-dismiss": "modal",
                          "aria-hidden": "true",
                        },
                      },
                      [
                        _c("svg", { attrs: { width: "20", height: "20" } }, [
                          _c("use", {
                            attrs: {
                              "xmlns:xlink": "http://www.w3.org/1999/xlink",
                              "xlink:href": "#svg-close",
                            },
                          }),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal__title" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(
                            _vm.$translate(
                              "ODFashioncode::Fashioncode.sizeTable"
                            )
                          ) +
                          "\n                        "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm._t("category-template-size-table"),
                ],
                2
              ),
            ]),
          ]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }